import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { OperationsRole } from '@/models/user.model';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: OperationsRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles 
}) => {
  const { profile, loading } = useAuth();
  const normalizedRole =
    profile?.role === 'operationsAdmin' ? OperationsRole.operationsAdmin : profile?.role;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!profile) {
    return <Navigate to="/login" replace />;
  }

  if (!profile.isActive) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && requiredRoles.length > 0 && (!normalizedRole || !requiredRoles.includes(normalizedRole))) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

